// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bfg_a bia_bk bia_bl bia_bo","SwipeLeftToClose--animating":"bfg_b"};